export default "__VITE_ASSET__BSVLthne__"